import { updateProjectMetadata } from "../ProjectSlice_Store";
import type { ChatDispatch } from "./chatSliceTypes";

/** The notification envelope the core agent puts on `channelData.notification`. */
export interface ChatNotification {
  type?: string;
  project_id?: string;
  name?: string;
  summary?: string;
}

/** Redux is the single source of truth here; the listener has no closure state. */
const currentState = (): any => window.store?.getState();

const isForCurrentProject = (notification: ChatNotification): boolean => {
  const currentProjectId = currentState()?.projectSlice?.currentProjectId;
  return Boolean(notification.project_id && notification.project_id === currentProjectId);
};

/**
 * Route a control-channel notification. Returns true when the activity was a
 * notification and must not fall through to normal message handling.
 */
export function handleNotification(
  notification: ChatNotification | undefined,
  dispatch: ChatDispatch
): boolean {
  if (!notification) return false;

  if (notification.type === "project_checkpoint_update") {
    if (isForCurrentProject(notification)) {
      // Update project metadata in Redux store (no chat message shown)
      dispatch(
        updateProjectMetadata({ name: notification.name, summary: notification.summary })
      );
    }
    return true;
  }

  return false;
}
